import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { profileMenusConst } from '../../data-access/constants/profile-menus.const';
import { UserPreviewComponent } from '../../components/user-preview/user-preview.component';
import { PayClubPreviewComponent } from '../../components/pay-club-preview/pay-club-preview.component';
import { ProfileMenuGroupComponent } from '../../components/profile-menu-group/profile-menu-group.component';
import { SubscriptionPreviewComponent } from '../../components/subscription-preview/subscription-preview.component';
import { GuideChooserComponent } from '../../components/guide-chooser/guide-chooser.component';
import { AuthService } from '@client-monorepo/common/user';
import { Router } from '@angular/router';
import { ActionHandlerService, ActionType } from '@client-monorepo/common/action-handler';
import { SupportMessengerService } from '@client-monorepo/common/utilities';
import { LogoutConfirmationComponent } from '../../components/logout-confirmation/logout-confirmation.component';
import { FrequentServicesIdEnum } from '@client-monorepo/common/service-data';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { NgxEventTrackerService } from '@digipay/ngx-event-tracker';

@Component({
  selector: 'profile-applet-profile',
  standalone: true,
  imports: [
    CommonModule,
    UserPreviewComponent,
    SubscriptionPreviewComponent,
    PayClubPreviewComponent,
    ProfileMenuGroupComponent,
    NgxButtonComponent,
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileComponent implements OnDestroy {
  profileMenus = profileMenusConst;

  bottomSheetService = inject(NgxBottomSheetService);
  authService = inject(AuthService);
  router = inject(Router);
  actionHandlerService = inject(ActionHandlerService);
  private eventService = inject(NgxEventTrackerService);
  supportMessengerService = inject(SupportMessengerService);

  logout(): void {
    this.bottomSheetService.openBottomSheet(LogoutConfirmationComponent, {}, { noPadding: true });
    this.bottomSheetService.onClose.subscribe(() => {
      if (this.bottomSheetService.outputData() === 'logout') {
        this.eventService.logoutIntrack();
        this.authService.logout();
      }
    });
  }

  goToPayClub(): void {
    this.actionHandlerService.handle({
      type: ActionType.REDIRECT,
      payload: {
        url: '/pay-club',
      },
    });
  }

  goToSubscription(): void {
    this.actionHandlerService.handle({
      type: ActionType.REDIRECT,
      payload: {
        url: '/subscription',
      },
    });
  }

  goToInsurance(): void {
    this.actionHandlerService.handle({
      type: ActionType.GO_TO_SERVICE,
      payload: {
        serviceId: FrequentServicesIdEnum.ELECTRICAL_DEVICES_INSURANCE,
      },
    });
  }

  chooseSupportAction(item: string): void {
    if (item.includes('پشتیبانی')) {
      this.openChat();
    } else {
      this.openGuideChooser();
    }
  }

  openChat(): void {
    this.supportMessengerService.showFloatButton.set(false);
    this.supportMessengerService.isVisible.next(true);
    setTimeout(() => {
      this.supportMessengerService.toggleSupportMessenger();
    }, 500);
  }

  openGuideChooser(): void {
    this.bottomSheetService.openBottomSheet(GuideChooserComponent, null);
  }

  ngOnDestroy(): void {
    this.supportMessengerService.hide();
    this.supportMessengerService.showFloatButton.set(true);
  }
}
